import React from 'react'
import WhitePanel from '../../UI/white-panel/whitePanel'
import { VODData } from '../../action/VodAction'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import SearchBar from '../../UI/search-bar/searchBar'
import { movies } from '../../config/constant'
import VODMenu from './VODMenu/VODMenu'
import Genre from './genre/genre'
import SearchMovies from './search-movies/searchMovies'
import MovieByLanguage from './movies-by-language/movieByLanguage'
import { heightFix } from '../../JS/heightFix'
import { setDeviceLoginPage } from '../../action/action'

class vod extends React.Component {

  componentDidMount() {
    heightFix()
    this.props.VODData("/videolib/fetch");
    let SessionToken = localStorage.getItem("GuestJourneySessionToken");
    let room = localStorage.getItem("room")
    if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
      console.log("h-commerce widget: no session token");
      if (this.props.currentWidget.widgetType && !room || room === "null") {
        this.props.setDeviceLoginPage(true);
        console.log("room", room);
      } else {
        console.log("there is some bug in guest registration flow.")
      }
    }
  }

  page = () => {
    switch (this.props.pageNumber) {
      case 1:
        return <VODMenu />
      case 'Genre':
        return <Genre />
      case 3:
        return <SearchMovies />
      case 'Language':
        return <MovieByLanguage />
      default:
        return <VODMenu />
    }
  }
  render() {
    return (
      <div id="movies" className="contentSection">
        {this.page()}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    pageNumber: state.store.vod.pageNumber,
    currentWidget: state.store.sideNavBar.currentWidget,
    guestDetails: state.store.home.guestDetails,
  }
}

vod.propTypes = {
  stringConst: propTypes.object,

}

export default connect(
  mapStateToProps,
  {
    VODData,
    setDeviceLoginPage
  }
)(vod);

/*
<SearchBar list={movies} />
  <div className="movie-container">
    <WhitePanel
      title={`${this.props.stringConst.vodTitle}`}
      styleClasses="movie-list">
      <ul className="movie-list-items">
        {
          movies.map((iterator) => {
            return (
              <li
                className="movie-item"
                style={{
                  backgroundImage: `url('${iterator.image}')`,
                  backgroundSize: 'cover'
                }}>
                <i className="fa fa-play"></i>
              </li>
            )
          })
        }
      </ul>
    </WhitePanel>
  </div>
  */